var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddTaskCal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4091_81423)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 1.33333C13.4707 1.33333 14.6667 2.52933 14.6667 4V12C14.6667 13.4707 13.4707 14.6667 12 14.6667H4C2.52933 14.6667 1.33333 13.4707 1.33333 12V4C1.33333 2.52933 2.52933 1.33333 4 1.33333H12ZM12 0H4C1.79067 0 0 1.79067 0 4V12C0 14.2093 1.79067 16 4 16H12C14.2093 16 16 14.2093 16 12V4C16 1.79067 14.2093 0 12 0Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99967 12C7.63167 12 7.33301 11.702 7.33301 11.3333V4.66667C7.33301 4.29867 7.63167 4 7.99967 4C8.36767 4 8.66634 4.29867 8.66634 4.66667V11.3333C8.66634 11.702 8.36767 12 7.99967 12Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 8.0026C4 7.6346 4.298 7.33594 4.66667 7.33594H11.3333C11.7013 7.33594 12 7.6346 12 8.0026C12 8.3706 11.7013 8.66927 11.3333 8.66927H4.66667C4.298 8.66927 4 8.3706 4 8.0026Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4091_81423"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddTaskCal);
export default __webpack_public_path__ + "static/media/AddTaskCal.771888c2c572aae07401673fd1ec9c32.svg";
export { ForwardRef as ReactComponent };